export default __webpack_public_path__ + "7de8c4ec8b802713f193f8a9a1a94358.svg";